export class ContestMakeView {
  id: string;
  name: string;
  isLoading: boolean;
  start: string;
  end: string;
  showAllArmies: boolean;
  mustAddTeam: boolean;
  mustAddParticipant: boolean;

  constructor(params: ContestMakeViewParams) {
    this.id = params.id;
    this.name = params.name;
    this.isLoading = params.isLoading;
    this.start = params.start;
    this.end = params.end;
    this.showAllArmies = params.showAllArmies;
    this.mustAddTeam = params.mustAddTeam;
    this.mustAddParticipant = params.mustAddParticipant;
  }
}

export type ContestMakeViewParams = {
  id: string;
  name: string;
  isLoading: boolean;
  start: string;
  end: string;
  showAllArmies: boolean;
  mustAddTeam: boolean;
  mustAddParticipant: boolean;
};
